import Link from 'next/link';

import XImage from '@/components/@base/x-image';
import Props from '@/components/layout/components/[default]/header/@shared/topbar/banner/type';
import { useIncrementAdvertisementClick } from '@/components/shared/services/hooks';

import { DATA_CY_TOPBAR_LINK } from '@/constant/cypress';

export default function Banner({ id, desktopBanner, mobileBanner, buttonUrl }: Props) {
  const { mutate: incrementAdvertisementClick } = useIncrementAdvertisementClick();
  const handleClick = () => {
    if (id) incrementAdvertisementClick(id);
  };
  return (
    <>
      <Link
        href={buttonUrl}
        prefetch={false}
        target='_blank'
        rel='noopener noreferrer'
        data-cy={DATA_CY_TOPBAR_LINK}
        onClick={handleClick}
      >
        <XImage
          src={desktopBanner.publicLink}
          alt={desktopBanner?.name}
          fill
          className='hidden object-cover! md:block'
        />
      </Link>
      <Link
        href={buttonUrl}
        prefetch={false}
        target='_blank'
        rel='noopener noreferrer'
        data-cy={DATA_CY_TOPBAR_LINK}
        onClick={handleClick}
      >
        <XImage
          src={mobileBanner.publicLink}
          alt={mobileBanner?.name}
          fill
          className='object-cover! md:hidden'
        />
      </Link>
    </>
  );
}
